import * as React from "react";
import { Box, Stack, Typography } from "@mui/material";
import CclButton from "../../../components/common/cclButtons/cclButton";

interface InformationProps {}

const Information: React.FC<InformationProps> = () => {
    return (
        <Box
            sx={{
                display: "flex",
                w: 1,
                border: "1px solid #E0E0E0",
                borderRadius: "4px",
                paddingTop: "5px",
                paddingLeft: "8px",
                paddingBottom: "5px",
            }}
        >
            <Stack
                direction={"row"}
                sx={{
                    width: 1,
                    alignItems: "center",
                }}
            >
                <Typography
                    variant="h6"
                    fontWeight={"bold"}
                    width={"12.5%"}
                    sx={{ marginLeft: "6px" }}
                >
                    Applications
                </Typography>
                <Box sx={{ marginLeft: "17px" }}>
                    <CclButton
                        mode="tertiary"
                        onClick={() => {
                            window.open(
                                "https://cclonline.crm.dynamics.com/main.aspx?appid=2939dc9a-0db8-ea11-a813-000d3a5a7503",
                                "_blank"
                            );
                        }}
                        sx={{ width: "122px", m: 1, padding: 2 }}
                    >
                        D365 PSA
                    </CclButton>
                    <CclButton
                        mode="tertiary"
                        onClick={() => {
                            window.open(
                                "https://app.powerbi.com/groups/280eb769-86ec-4f44-91d8-ee08967b5b54/reports/0a3fe2ff-1ede-4860-b6ff-b09567cd2605?ctid=6f6d1c6a-9e90-48b4-a00f-f4830e02a93e&pbi_source=linkShare",
                                "_blank"
                            );
                        }}
                        sx={{ width: "150px", m: 1, padding: 2 }}
                    >
                        Consent Dashboard
                    </CclButton>
                    <CclButton
                        mode="tertiary"
                        onClick={() => {
                            window.open("https://cclaccess.ccl.org/", "_blank");
                        }}
                        sx={{ width: "122px", m: 1, padding: 2 }}
                    >
                        CCL Scoring
                    </CclButton>
                    <CclButton
                        mode="tertiary"
                        onClick={() => {
                            window.open("http://vgsoweb01/GroupReports/Views/home.aspx", "_blank");
                        }}
                        sx={{ width: "122px", m: 1, padding: 2 }}
                    >
                        Group Reports
                    </CclButton>
                    <CclButton
                        mode="tertiary"
                        onClick={() => {
                            window.open("https://ias.ccl.org/", "_blank");
                        }}
                        sx={{ width: "75px", m: 1, padding: 2 }}
                    >
                        IAS
                    </CclButton>
                    <CclButton
                        mode="tertiary"
                        onClick={() => {
                            window.open("https://www.datasltn.com/wss/CCLLogin.cfm", "_blank");
                        }}
                        sx={{ width: "75px", m: 1, padding: 2 }}
                    >
                        DSI
                    </CclButton>
                </Box>
            </Stack>
        </Box>
    );
};

export default Information;
